"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var __exports_1 = require("../__exports");
require("./Dialog.css");
var utils_1 = require("../utils");
/**
 * @see DialogProps
 */
var Dialog = /** @class */ (function (_super) {
    __extends(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        /* Will use last focused element, before dialog was opened, and then return focus to it */
        _this.restoreLastFocus = function () {
            if (_this.lastFocus && _this.lastFocus.focus) {
                _this.lastFocus.focus();
                _this.lastFocus = null;
                if (document) {
                    document.removeEventListener('focus', _this.enforceFocus, true);
                }
            }
        };
        /* When modal is opened will force focus back to first focusable element in the footer of the dialog */
        /* istanbul ignore next */
        _this.enforceFocus = function (e) {
            if (_this.props.isVisible) {
                if (_this.contentRef && !utils_1.contains(_this.contentRef, document.activeElement)) {
                    e.stopPropagation();
                    _this.contentRef.focus();
                }
            }
        };
        _this._onClose = _this._onClose.bind(_this);
        _this._escHandler = _this._escHandler.bind(_this);
        _this._dialogID = _this.props.id || "dialog_" + __exports_1.default.createUUID();
        return _this;
    }
    Dialog.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.isVisible && !prevProps.isVisible) {
            this.lastFocus = document.activeElement;
            if (!this.props.usePortal)
                this.refDialog.focus();
            this.whenVisible();
            window.addEventListener('keydown', this._escHandler);
            __exports_1.default.addNoScroll();
        }
        else if (!this.props.isVisible && prevProps.isVisible) {
            window.removeEventListener('keydown', this._escHandler);
            __exports_1.default.removeNoScroll();
            this.restoreLastFocus();
        }
    };
    Dialog.prototype.componentWillUnmount = function () {
        window.removeEventListener('keydown', this._escHandler);
    };
    Dialog.prototype._onClose = function () {
        if (this.props.onClose) {
            this.props.onClose(this.props.id);
        }
        this.restoreLastFocus();
    };
    /* istanbul ignore next */
    Dialog.prototype._escHandler = function (e) {
        if (e.keyCode === 27) {
            this._onClose();
        }
    };
    /* adds even listener when the dialog becomes visible on page */
    Dialog.prototype.whenVisible = function () {
        if (document) {
            document.addEventListener('focus', this.enforceFocus, true);
            if (this.contentRef) {
                this.contentRef.focus();
            }
        }
    };
    Dialog.prototype.renderDialog = function () {
        var _this = this;
        var _a = this.props, title = _a.title, isVisible = _a.isVisible, children = _a.children, footer = _a.footer, useCustomFooter = _a.useCustomFooter, tag = _a.tag, canClickOut = _a.canClickOut, onRef = _a.onRef;
        var cssDialog = ['p-dialog'];
        var propsDialog = {};
        if (isVisible)
            cssDialog.push('is-visible');
        var contentId = this._dialogID + "_content";
        propsDialog = {
            ref: function (r) {
                onRef && onRef(r);
                _this.refDialog = r;
            },
            tabIndex: this.props.isVisible ? 0 : -1,
            className: cssDialog.join(' '),
            role: 'alertdialog',
            'aria-label': title,
            'aria-describedby': contentId,
            'aria-modal': true
        };
        var cssFooter = ['content-foot'];
        if (useCustomFooter)
            cssFooter.push('custom');
        var onClickProp = canClickOut ? { onClick: this._onClose } : {};
        return (React.createElement("div", __assign({}, propsDialog, { "data-tag": tag }),
            React.createElement("div", __assign({ className: "background" }, onClickProp)),
            React.createElement("div", { className: "content", id: this._dialogID, role: "dialog", tabIndex: -1, ref: function (ref) {
                    _this.contentRef = ref;
                } },
                React.createElement("section", { className: "content-body", id: contentId }, children),
                React.createElement("footer", { ref: function (r) {
                        _this.footerRef = r;
                    }, className: cssFooter.join(' ') }, footer))));
    };
    Dialog.prototype.render = function () {
        var _a = this.props, isVisible = _a.isVisible, canClickOut = _a.canClickOut, usePortal = _a.usePortal;
        if (usePortal) {
            return (React.createElement(__exports_1.default.Portal, { isOpened: isVisible, closeOnOutsideClick: canClickOut, closeOnEsc: true }, this.renderDialog()));
        }
        else {
            return this.renderDialog();
        }
    };
    Dialog.defaultProps = {
        id: '',
        title: '',
        isVisible: true,
        children: [],
        footer: [],
        useCustomFooter: false,
        tag: null,
        onClose: void 0,
        onRef: void 0,
        canClickOut: true,
        usePortal: false
    };
    return Dialog;
}(React.Component));
exports.Dialog = Dialog;
exports.default = Dialog;
//# sourceMappingURL=Dialog.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/dialog/build/control/Dialog.js
// module id = 574
// module chunks = 0